import { IEvent } from "../../interfaces/models/IEvent";
import { ITab } from "../../interfaces/models/IEvent";

export const EventEmpty: IEvent = {
  id: "",
  createdDate: 0,
  _ts: 0,
  isDeleted: false,
  shortId: "",
  eventType: "inPerson",
  setupType: null,
  title: "",
  comingSoonDate: true,
  comingSoonLocation: true,
  eventHostSponsor: "wsg",
  status: "private",
  tabs: [
    { type: "overview", index: 0 },
    { type: "registration", index: 1 },
    { type: "attendees", index: 2 },
    { type: "contactUs", index: 3 },
  ] as ITab[],
};


